export default [{
  state: 'Baden-Württemberg',
  stateShort: 'BW',
  gridPosition: [5, 1],
  aboveAvg: false
}, {
  state: 'Bayern',
  stateShort: 'Bayern',
  gridPosition: [5 ,2],
  aboveAvg: false
}, {
  state: 'Berlin',
  stateShort: 'Berlin',
  gridPosition: [2, 2],
  aboveAvg: false
}, {
  state: 'Brandenburg',
  stateShort: 'Brandenburg',
  gridPosition: [2, 3],
  aboveAvg: true
}, {
  state: 'Bremen',
  stateShort: 'Bremen',
  gridPosition: [2, 0],
  aboveAvg: false
}, {
  state: 'Hamburg',
  stateShort: 'Hamburg',
  gridPosition: [1, 1],
  aboveAvg: false
}, {
  state: 'Hessen',
  stateShort: 'Hessen',
  gridPosition: [3, 1],
  aboveAvg: false
}, {
  state: 'Mecklenburg-Vorpommern',
  stateShort: 'MV',
  gridPosition: [1, 2],
  aboveAvg: true
}, {
  state: 'Niedersachsen',
  stateShort: 'Niedersachsen',
  gridPosition: [2, 1],
  aboveAvg: false
}, {
  state: 'Nordrhein-Westfalen',
  stateShort: 'NRW',
  gridPosition: [3, 0],
  aboveAvg: false
}, {
  state: 'Rheinland-Pfalz',
  stateShort: 'Rheinland-Pfalz',
  gridPosition: [4, 1],
  aboveAvg:  false
}, {
  state: 'Saarland',
  stateShort: 'Saarland',
  gridPosition: [4, 0],
  aboveAvg:  false
}, {
  state: 'Sachsen-Anhalt',
  stateShort: 'Sachsen-Anhalt',
  gridPosition: [3, 2],
  aboveAvg: true
}, {
  state: 'Sachsen',
  stateShort: 'Sachsen',
  gridPosition: [3, 3],
  aboveAvg: true
}, {
  state: 'Schleswig-Holstein',
  stateShort: 'Schleswig-Holstein',
  gridPosition: [0, 1],
  aboveAvg: false
}, {
  state: 'Thüringen',
  stateShort: 'Thüringen',
  gridPosition: [4, 2],
  aboveAvg: true
}];
